/**
 * Medbook
 * Medbook api
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 */
export type ReportSubTypeEnum = 'training' | 'department' | 'organisation';

export const ReportSubTypeEnum = {
    Training: 'training' as ReportSubTypeEnum,
    Department: 'department' as ReportSubTypeEnum,
    Organisation: 'organisation' as ReportSubTypeEnum
};

